import type { ReactNode } from "react";

import { cn } from "#/lib/utils";

type SectionHeaderProps = {
  children: ReactNode;
  className?: string;
};

export function SectionHeader({ children, className }: SectionHeaderProps) {
  return (
    <h2 className={cn("text-2xl font-semibold tracking-tight text-foreground", className)}>
      {children}
    </h2>
  );
}
